import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { AdminCalendar } from './AdminCalendar';
import { AdminGallery } from './AdminGallery';
import { Button } from './ui/button';

export const AdminDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm p-4">
        <div className="max-w-7xl mx-auto flex gap-4">
          <Link to="/admin">
            <Button variant="outline">Manage Calendar</Button>
          </Link>
          <Link to="/admin/gallery">
            <Button variant="outline">Manage Gallery</Button>
          </Link>
          <Link to="/">
            <Button variant="outline">Back to Website</Button>
          </Link>
        </div>
      </nav>

      <div className="py-8">
        <Routes>
          <Route path="/" element={<AdminCalendar />} />
          <Route path="/gallery" element={<AdminGallery />} />
        </Routes>
      </div>
    </div>
  );
};
